import SsoForm, {
  marketTheme as theme,
  en as messages,
  Features
} from '@envato/sso-forms-standalone'

import GoogleAnalytics from '../../utils/googleAnalytics'

const SIGN_UP_FIELDS_SELECTOR = '.js-sign-up-field'
const SIGN_IN_FIELDS_SELECTOR = '.js-sign-in-field'
const FORM_SELECTOR = '.js-verify_token__session-form'
const FORM_TOKEN_SELECTOR = '.js-verify_token__session-token'

class SsoForms {
  constructor (props) {
    this.props = props

    this.flow = props.flow || 'signin'

    this.formRef = { current: null }
  }

  renderForm () {
    if (this.props.fullWidth) {
      theme.formWidth = '100%'
    }

    const config = {
      languageCode: 'en',
      flow: this.flow,
      rootElement: this.props.rootElement,
      ssoHost: this.props.ssoServerDomain,
      messages,
      autoSignIn: true,
      clientSlug: this.props.ssoClientKey,
      clientAppId: 'market',
      theme,
      features: this.getFeatures(),
      analytics: {
        sendEvent: this.sendEvent
      },
      recaptchaV2SiteKey: this.props.recaptchaSiteKey,
      onSuccess: this.handleSuccess,
      onClickSignUp: () => this.showSignUp(),
      onClickSignIn: () => this.showSignIn(),
      hideFormElements: {
        toggleLink: !!this.props.toggleElement,
        submitButton: !!this.props.submitElement
      },
      formRef: this.formRef
    }

    SsoForm(config)

    this.addEventListeners()
  }

  showSignUp () {
    this.flow = 'signup'
    this.removeEventListeners()

    document.querySelectorAll(SIGN_UP_FIELDS_SELECTOR).forEach(e => e.classList.remove('hidden'))
    document.querySelectorAll(SIGN_IN_FIELDS_SELECTOR).forEach(e => e.classList.add('hidden'))
    this.renderForm()
  }

  showSignIn () {
    this.flow = 'signin'
    this.removeEventListeners()

    document.querySelectorAll(SIGN_IN_FIELDS_SELECTOR).forEach(e => e.classList.remove('hidden'))
    document.querySelectorAll(SIGN_UP_FIELDS_SELECTOR).forEach(e => e.classList.add('hidden'))
    this.renderForm()
  }

  handleSuccess (token) {
    document.querySelector(FORM_TOKEN_SELECTOR).value = token
    document.querySelector(FORM_SELECTOR).submit()
  }

  addEventListeners () {
    if (this.props.submitElement) {
      this.handleSubmit = () => {
        if (this.formRef.current) {
          this.formRef.current.submit()
        }
      }

      document
        .querySelector(this.props.submitElement)
        .addEventListener('click', this.handleSubmit)
    }

    if (this.props.toggleElement) {
      this.toggleFlow = () => {
        if (this.flow === 'signup') {
          this.showSignIn()
        } else {
          this.showSignUp()
        }
      }

      document
        .querySelector(this.props.toggleElement)
        .addEventListener('click', this.toggleFlow)
    }
  }

  removeEventListeners () {
    if (this.toggleFlow) {
      document.querySelector(this.props.toggleElement).removeEventListener('click', this.toggleFlow)
      this.toggleFlow = undefined
    }

    if (this.handleSubmit) {
      document.querySelector(this.props.submitElement).removeEventListener('click', this.handleSubmit)
      this.handleSubmit = undefined
    }
  }

  sendEvent (event) {
    GoogleAnalytics.sendEvent('event', event.category, event.action, { label: event.label, value: event.value })
  }

  getFeatures () {
    const featureList = [
      Features.AppleAuth,
      Features.FacebookAuth,
      Features.LoginWithEmail
    ]

    return featureList
  }
}

export default SsoForms
